// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-data-table[data-v-6d9907e3] {\n  max-width: 70% !important;\n  width: 27.5rem !important;\n}", ""]);
// Exports
module.exports = exports;
